module.exports = __webpack_public_path__ + "img/edit_rotate.6ed3515.png";